/**
 * Vue mixin for common user methods.
 * @author bmk11u ab557z
 */
// import $cookies from 'vue-cookies'
import * as lst from '@/components/localStorage.js'

export default {
  methods: {
    // Check the guid to work out if the user is student or staff.
    isStudent () {
      const guid = lst.getUserGuid()

      if (guid[0] >= '0' && guid[0] <= '9') {
        return true
      } else {
        return false
      }
    }
  }
}
